import { css } from '@linaria/core';
const Hidden = {
    base: css `
		position: fixed !important;

		overflow: hidden;
		display: inline-block !important;

		width: 1px !important;
		height: 1px !important;
		margin: 0 !important;
		padding: 0 !important;
		border: 0 !important;

		/* stylelint-disable-next-line -- we have to set it to 0 to hide it */
		font-size: 0 !important;
	`,
};
export default Hidden;
